<template>
  <div>
    <div class="widewrapper main">
      <div class="container">
          <div class="row">
              <div class="col-md-6 col-md-offset-3 clean-superblock" id="contact">
                  <h2>交个朋友</h2>
                  
                  <form accept-charset="utf-8" class="contact-form">
                      <input type="text" name="name" id="contact-name" placeholder="姓名" class="form-control input-lg">
                      <input type="text" name="email" id="contact-email" placeholder="邮箱" class="form-control input-lg">
                      <textarea rows="10" name="message" id="contact-body" placeholder="留个言吧" class="form-control input-lg"></textarea>
                      <div class="buttons clearfix">
                          <button type="button" class="btn btn-xlarge btn-clean-one">提交</button>
                      </div>                    
                  </form>
              </div>
          </div>        
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact',
  metaInfo: {
      meta: [
          { name: 'keywords', content: '范祯的博客' },
          { name: 'description', content: '前360资深研发，分享些有趣好玩的东西' }
      ]
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Contact.vue